import React from "react";
import Header from "../../components/Header/Header";
import { Fade } from "react-awesome-reveal";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import "./Project.css";
import { projectsHeader } from "../../shared/constants";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import Projects from "../../components/Projects/Projects";

export default function ProjectScreen(props: any) {
  const theme = props.theme;
  return (
    <div>
      <div className="projects-main">
        <div className="BackgroundHome">
          <Header theme={theme} />
          <div className="basic-projects">
            <Fade duration={2000}>
              <section className="section section-lg section-shaped pb-250">
                <div className="shape shape-style-1 bg-gradient-info">
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                </div>
                <div className="projects-heading-div">
                  <div className="projects-heading-img-div">
                    <DisplayLottie animationPath="/lottie/project.json" />
                  </div>
                  <div className="projects-heading-text-div">
                    <h1
                      className="projects-heading-text"
                      style={{ color: theme.white, marginBottom: "1rem" }}
                    >
                      {projectsHeader.title}
                    </h1>
                    <p
                      className="projects-header-detail-text subTitle"
                      style={{ color: theme.white }}
                    >
                      {projectsHeader["description"]}
                    </p>
                  </div>
                </div>
              </section>
            </Fade>
          </div>
        </div>
        <Projects theme={props.theme} />
      </div>
      <Footer theme={props.theme} />
      <TopButton theme={props.theme} />
    </div>
  );
}
